import React, { FC } from "react";

import { FaIcons } from "@in/component-library";
import { useLayout } from "../../hooks/use-layout";
import { ApplicationWithCategoryType } from "../../pages/applications/applications";
import ActionTool from "../action-tool/action-tool";

interface ShareApplicationToolProps {
  application: ApplicationWithCategoryType;
  iconButton?: boolean;
}

const ShareApplicationTool: FC<ShareApplicationToolProps> = ({ application, iconButton }) => {
  const { translations } = useLayout();

  const handleShare = () => {
    window.location.href = application.shareUrl;
  };

  return (
    <ActionTool
      onClick={handleShare}
      iconName={FaIcons.ShareLight}
      label={translations.applicationsActionShare}
      iconButton={iconButton}
      ariaLabel={`${translations.applicationsActionShare} ${application.title}`}
    />
  );
};

export default ShareApplicationTool;
